import React from 'react';
import { Form, Row, Col } from 'reactstrap';
import InputReadOnlyWithCopy from '../common/InputReadOnlyWithCopy';
import { FMessage } from '../../hoc/IntlComponents';
import Card from '../Card/Card';

const AddMemberForm = ({ tabProps: { master }, onSubmit, handleClose }) => {
  return (
    <Card.Body>
      <p>
        <FMessage id="slaves.add-member.bottom-text" />
      </p>
      <Form onSubmit={onSubmit} className="add-member">
        <InputReadOnlyWithCopy
          id="slaves.add-member.link.title"
          value={master.master.hash}
          handleClose={handleClose}
        />
      </Form>
    </Card.Body>
  );
};

export default AddMemberForm;
